# Generated from app.intent.md — do not edit manually
# Route: /materials/lots/:lotId/inspect
# Audience: Operators (md+), blocked on sm
# Ref: app.intent.md § Quality Inspection

page-inspection:
  type: Page
  archetype: edit
  meta:
    title: $t.quality_inspection.meta_title
    auth: required
  data:
    lot:
      model: ItemLot
      key: $route.lotId
      required: true
  spatial:
    display: flex
    direction: column
    gap: $spacing.lg
    padding: $spacing.lg
    padding_inline: $spacing.xl
    overflow: auto
  tokens:
    background: $color_scheme.light.color.surface
  children:
    - inspection-sm-notice
    - inspection-content

# ── sm viewport notice ───────────────────────────────────────────────────────

inspection-sm-notice:
  type: SmNotice
  content: $t.common.sm_notice_inspect

# ── Main content (hidden on sm) ──────────────────────────────────────────────

inspection-content:
  type: Section
  spatial:
    display: flex
    direction: column
    gap: $spacing.lg
    responsive:
      sm:
        display: none
  children:
    - inspection-page-header
    - inspection-lot-info
    - inspection-form

# ── Page header ──────────────────────────────────────────────────────────────

inspection-page-header:
  type: PageHeader
  content: $t.quality_inspection.title
  back_route: /materials/lots/:lotId

# ── Lot info summary (canonical detail-page summary card) ───────────────────

inspection-lot-info:
  type: Card
  spatial:
    padding: $spacing.md
  children:
    - inspection-lot-info-row

inspection-lot-info-row:
  type: Section
  spatial:
    display: flex
    align: center
    gap: $spacing.md
  children:
    - inspection-lot-number
    - inspection-lot-material
    - inspection-lot-status

inspection-lot-number:
  type: Text
  bind:
    content: lot.lotNumber
  tokens:
    font_size: $font.size.md
    font_family: $font.family.mono
    color: $color_scheme.light.color.on-surface

inspection-lot-material:
  type: Text
  bind:
    content: lot.itemDefinitionId
  tokens:
    font_size: $font.size.sm
    color: $color_scheme.light.color.on-surface-muted

inspection-lot-status:
  type: StatusBadge
  bind:
    content: lot.qualityStatus
    variant:
      when: "lot.qualityStatus == 'RELEASED'"
      value: go
      else:
        when: "lot.qualityStatus == 'REJECTED'"
        value: stop
        else: caution

# ── Inspection form ──────────────────────────────────────────────────────────

inspection-form:
  type: Form
  model: RecordInspectionForm
  a11y:
    label: $t.quality_inspection.form_label
  # Recording an inspection is an act on the lot — the ItemLot `inspect`
  # operation (POST /api/items/lots/:id/inspect) — so the submit invokes it,
  # the way lot-scrap invokes `scrap`, and the lot id comes from the page's
  # `lot` data.
  action:
    type: invoke
    model: ItemLot
    operation: inspect
    # `on_success` is one value; a mapping is refused (XP85019). `:lotId`
    # resolves from the route.
    on_success: navigate(/materials/lots/:lotId)
  spatial:
    display: flex
    direction: column
    gap: $spacing.lg
  children:
    - inspection-field-inspector-id
    - inspection-field-inspected-at
    - inspection-results-heading
    - inspection-add-row
    - inspection-results-table
    - inspection-form-actions

inspection-field-inspector-id:
  type: Input
  input_type: text
  label: $t.quality_inspection.field_inspector_id
  bind: form.inspectedBy
  required: true
  spatial:
    max_width: 32rem
  a11y:
    label: $t.quality_inspection.field_inspector_id

inspection-field-inspected-at:
  type: Input
  input_type: datetime
  label: $t.quality_inspection.field_inspected_at
  bind: form.inspectedAt
  required: true
  spatial:
    max_width: 20rem
  a11y:
    label: $t.quality_inspection.field_inspected_at_label

inspection-results-heading:
  type: Text
  content: $t.quality_inspection.heading_results
  a11y:
    role: heading
    level: 2
  tokens:
    font_size: $font.size.lg
    font_family: $font.family.display
    color: $color_scheme.light.color.on-surface

inspection-results-table:
  type: Table
  bind:
    rows: form.results
  empty: inspection-empty
  columns:
    - key: parameterName
      label: $t.quality_inspection.col_parameter
    - key: measuredValue
      label: $t.quality_inspection.col_value
      tokens:
        font_family: $font.family.mono
    - key: unit
      label: $t.quality_inspection.col_unit
    - key: specificationName
      priority: low
      label: $t.quality_inspection.col_spec
    - key: lowerLimit
      priority: medium
      label: $t.quality_inspection.col_lower
      tokens:
        font_family: $font.family.mono
    - key: upperLimit
      priority: medium
      label: $t.quality_inspection.col_upper
      tokens:
        font_family: $font.family.mono
  a11y:
    label: $t.quality_inspection.table_label

inspection-empty:
  type: EmptyState
  content: $t.quality_inspection.empty
  body: $t.quality_inspection.empty_body

# Wrapper to prevent the button from stretching full-width in flex column.
inspection-add-row:
  type: Section
  spatial:
    display: flex
    direction: row
  children:
    - inspection-btn-add-result

# Secondary "Add row" action — outlined (not primary). The primary action
# of the whole page is the submit button in FormActions.
inspection-btn-add-result:
  type: Button
  variant: outlined
  color: info
  icon: plus
  content: $t.quality_inspection.btn_add_result
  a11y:
    label: $t.quality_inspection.btn_add_result_label
  action:
    type: custom
    event: add-inspection-row

# FormActions meta: sticky on sm/md, inline on lg+. submit_label + cancel_route
# is the canonical shorthand.
inspection-form-actions:
  type: FormActions
  submit_label: $t.quality_inspection.btn_submit
  cancel_route: /materials/lots/:lotId
  cancel_params:
    lotId: $route.lotId
